import {
    List,
    ListItem,
    ListItemButton,
    ListItemText,
} from "@mui/material";

type MenuListProps = {
  links: { label: string; path: string, slug?: string }[];
  onNavigate: (path: string, slug?: string) => void;
  activePath: string;
  border?: boolean;
};

export default function MenuList({
  links,
  onNavigate,
  activePath,
  border = true,
}: MenuListProps) {
  return (
    <List sx={{ paddingTop: "64px" }}>
      {links.map((link) => (
        <ListItem key={link.label} disablePadding>
          <ListItemButton
            onClick={() => onNavigate(link.path, link.slug)}
            sx={{
              borderBottom: border ? "1px solid #3F4E8C" : "none",
            }}
          >
            <ListItemText
              primary={link.label}
              primaryTypographyProps={{
                style: {
                  fontWeight: activePath === link.path ? "700" : "normal",
                },
              }}
            />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
}
